import React, { useContext, useState, useEffect } from 'react';
import toast from 'react-hot-toast';

import { DataContext } from '../../../init/getData';

import { Col, Form, Row, DropdownButton, Dropdown, InputGroup } from 'react-bootstrap';
import { Space, Input, Tag, Button, Spin, Tabs } from 'antd';
import Modal from 'react-bootstrap/Modal';

import { FiEdit } from "react-icons/fi";
import { FcUndo, FcRefresh, FcFlowChart, FcRules } from "react-icons/fc";
import { BiSolidTrash, BiExport } from "react-icons/bi";
import { IoBarcodeOutline } from "react-icons/io5";
import { FcKindle, FcCancel, FcPlus } from "react-icons/fc";
import { FaCheck } from "react-icons/fa";
import { HiMinusCircle } from "react-icons/hi";

import Select from 'react-select';
import AsyncSelect from 'react-select/async';
import Loader from '../../../components/loader/loader';

import { numberFormatter, totalFormatter, decimalFormatter } from '../../../components/formatters/numberFormatter';

const InvoiceTotal = (props) => {

    const { subTotal, cartDiscounts, journalVoucher, setJournalVoucher, total, discountPercentage,
        totalDiscounts, vat, netCharges, netTotal, discountAmount, selectedCurrency } = props;

    const { api, userData, settingData, accountData, wareHouseData, selectedCompany,
        productData, refData, branchData, projectData, mainCurrency, secondaryCurrency, rateFromToCurrency,
        currencyData } = useContext(DataContext);


    const userId = userData.id;
    const userName = userData.name;
    const userRole = userData.role.name;
    const createdBy = parseInt(userData.id);


    const [loadingEffect, setLoadingEffect] = useState(false);
    const [validated, setValidated] = useState(false);
    const [isSpinning, setIsSpinning] = useState(false);
    const [isLoading, setIsLoading] = useState(true);



    // Generic handler for input changes
    const handleInputChange = (e, type) => {
        let { name, value } = e.target;
        
        if (type == 'number') {
            value = parseFloat(value)
        } else if (type == 'boolean') {
            value = JSON.parse(value)
        }

        // change discount Percentage
        if (name == 'discountAmount') {
            const discountPercentage = (value / subTotal) * 100;
            setJournalVoucher((prev) => ({
                ...prev,
                discountPercentage: discountPercentage,
            }));
        }
        // change discount Amount
        else if (name == 'discountPercentage') {
            const discountAmount = (value / 100) * (subTotal - cartDiscounts);
            setJournalVoucher((prev) => ({
                ...prev,
                discountAmount: discountAmount,
            }));
        }
        setJournalVoucher((prev) => ({
            ...prev,
            [name]: value,
        }));
    };


    const disabledDiscountMainCurrency = (journalVoucher.discountType !== 'amount') || (selectedCurrency?.id !== mainCurrency?.id);
    const disabledDiscountSecondaryCurrency = (journalVoucher.discountType !== 'amount') || (selectedCurrency?.id !== secondaryCurrency?.id);



    return (
        <div>


            <Row className='g-0'>
            <Col md={2}>
                <Form.Label >
                    Cart Discounts
                </Form.Label>
                </Col>
                <Col md={5}>
                    <InputGroup>
                        <Form.Control type="text" value={numberFormatter(rateFromToCurrency(selectedCurrency, mainCurrency, cartDiscounts))} disabled />
                        <InputGroup.Text>{mainCurrency?.symbol}</InputGroup.Text>
                    </InputGroup>
                </Col>
                <Col md={3}>
                    <InputGroup>
                        <Form.Control type="text" value={numberFormatter(rateFromToCurrency(selectedCurrency, secondaryCurrency, cartDiscounts))} disabled />
                        <InputGroup.Text>{secondaryCurrency?.symbol}</InputGroup.Text>
                    </InputGroup>
                </Col>
            </Row>
            
            <Row className='g-0'>
            <Col md={2}>
                <Form.Label>
                    SUB Total
                </Form.Label>
                </Col>
                <Col md={5}>
                    <InputGroup>
                        <Form.Control type="text" value={numberFormatter(rateFromToCurrency(selectedCurrency, mainCurrency, subTotal))} disabled />
                        <InputGroup.Text>{mainCurrency?.symbol}</InputGroup.Text>
                    </InputGroup>
                </Col>
                
                <Col md={3}>
                    <InputGroup>
                        <Form.Control type="text" value={numberFormatter(rateFromToCurrency(selectedCurrency, secondaryCurrency, subTotal))} disabled />
                        <InputGroup.Text>{secondaryCurrency?.symbol}</InputGroup.Text>
                    </InputGroup>
                </Col>
            </Row>


            <Row className='g-0'>
            <Col md={2}>
                <Form.Label>
                    InvoiceDiscount
                </Form.Label>
                </Col>
                <Col md={2}>
                    <InputGroup>
                        <Form.Control

                            type="text"
                            name="discountPercentage"
                            value={discountPercentage}
                            onChange={(e) => handleInputChange(e, 'text')}
                            disabled={journalVoucher.discountType !== 'percentage'}
                        />
                        <InputGroup.Text>%</InputGroup.Text>
                    </InputGroup>
                </Col>

                    <Col md={3}>
                    <InputGroup>
                        <Form.Control
                            type="text"
                            name="discountAmount"
                            value={disabledDiscountMainCurrency ? numberFormatter(rateFromToCurrency(selectedCurrency, mainCurrency, discountAmount)) : discountAmount}
                            onChange={(e) => handleInputChange(e, 'text')}
                            disabled={disabledDiscountMainCurrency} />
                        <InputGroup.Text>{mainCurrency?.symbol}</InputGroup.Text>
                    </InputGroup>
                </Col>

                <Col md={3}>
                    <InputGroup>
                        <Form.Control
                            type="text"
                            name="discountAmount"
                            value={disabledDiscountSecondaryCurrency ? numberFormatter(rateFromToCurrency(selectedCurrency, secondaryCurrency, discountAmount)) : discountAmount}
                            onChange={(e) => handleInputChange(e, 'text')}
                            disabled={disabledDiscountSecondaryCurrency} />
                        <InputGroup.Text>{secondaryCurrency?.symbol}</InputGroup.Text>
                    </InputGroup>
                </Col>
            </Row>


            <Row className='g-0'>
            <Col md={2}>
                <Form.Label>
                    Total
                </Form.Label>
                </Col>
                <Col md={5}>
                    <InputGroup>
                        <Form.Control type="text" value={numberFormatter(rateFromToCurrency(selectedCurrency, mainCurrency, total))} disabled />
                        <InputGroup.Text>{mainCurrency?.symbol}</InputGroup.Text>
                    </InputGroup>
                </Col>
                <Col md={3}>
                    <InputGroup>
                        <Form.Control type="text" value={numberFormatter(rateFromToCurrency(selectedCurrency, secondaryCurrency, total))} disabled />
                        <InputGroup.Text>{secondaryCurrency?.symbol}</InputGroup.Text>
                    </InputGroup>
                </Col>
            </Row>


            <Row className='g-0'>
            <Col md={2}>
                <Form.Label>
                    VAT
                </Form.Label>
                </Col>
                <Col md={5}>
                    <InputGroup>
                        <Form.Control type="text" value={numberFormatter(rateFromToCurrency(selectedCurrency, mainCurrency, vat))} disabled />
                        <InputGroup.Text>{mainCurrency?.symbol}</InputGroup.Text>
                    </InputGroup>
                </Col>
                <Col md={3}>
                    <InputGroup>
                        <Form.Control type="text" value={numberFormatter(rateFromToCurrency(selectedCurrency, secondaryCurrency, vat))} disabled />
                        <InputGroup.Text>{secondaryCurrency?.symbol}</InputGroup.Text>
                    </InputGroup>
                </Col>
            </Row>


            <Row className='g-0'>
            <Col md={2}>
                <Form.Label column="sm" sm="3">
                    Charges
                </Form.Label>
                </Col>
                <Col md={5}>
                    <InputGroup>
                        <Form.Control type="text" value={numberFormatter(rateFromToCurrency(selectedCurrency, mainCurrency, netCharges))} disabled />
                        <InputGroup.Text>{mainCurrency?.symbol}</InputGroup.Text>
                    </InputGroup>
                </Col>
                <Col md={3}>
                    <InputGroup>
                        <Form.Control type="text" value={numberFormatter(rateFromToCurrency(selectedCurrency, secondaryCurrency, netCharges))} disabled />
                        <InputGroup.Text>{secondaryCurrency?.symbol}</InputGroup.Text>
                    </InputGroup>
                </Col>
            </Row>


            <Row className='g-0'>
            <Col md={2}>
                <Form.Label column="sm" sm="3">
                    NetTotal
                </Form.Label>
                </Col>
                <Col md={5}>
                    <InputGroup>
                        <Form.Control type="text" value={numberFormatter(rateFromToCurrency(selectedCurrency, mainCurrency, netTotal))} disabled />
                        <InputGroup.Text>{mainCurrency?.symbol}</InputGroup.Text>
                    </InputGroup>
                </Col>
                <Col md={3}>
                    <InputGroup>
                        <Form.Control type="text" value={numberFormatter(rateFromToCurrency(selectedCurrency, secondaryCurrency, netTotal))} disabled />
                        <InputGroup.Text>{secondaryCurrency?.symbol}</InputGroup.Text>
                    </InputGroup>
                </Col>
            </Row>


            <Row className='g-0'>
            <Col md={2}>
                <Form.Label>
                    DiscountType
                </Form.Label>
                </Col>
                <Col md={2}>
                    <Form.Select name="discountType"
                        value={journalVoucher.discountType}
                        onChange={(e) => handleInputChange(e, 'text')}
                    >
                        <option value={'percentage'}>Percentage</option>
                        <option value={'amount'}>Amount</option>
                    </Form.Select>
                </Col>
            </Row>


        </div>
    )
}


export default InvoiceTotal;